export default "__VITE_ASSET__BqX1F8_e__"